import { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsVisible(scrollTop > 200);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      style={{
        zIndex: "999",
      }}
      className={`fixed bottom-2 z-50 right-20   transition-opacity  flex items-center justify-center font-semibold ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      } `}
      aria-label="Scroll to top"
    >
      <button
       aria-label="scroll To Top"
        onClick={scrollToTop}
        className="group relative inline-flex  mt-3 w-14 h-14  items-center rounded-full font-semibold text-white bg-transparent overflow-hidden"
      >
        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
          <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
            <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
            <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
            <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
          </span>
        </span>
        <span className="relative">
          <span className="flex flex-row gap-2 justify-center ps-4 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
            <ArrowUpwardIcon />
          </span>
          <span className="absolute flex flec-row gap-2 top-0 ps-4  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
            <ArrowUpwardIcon />
          </span>
        </span>
      </button>
    </div>
  );
};

export default ScrollToTopButton;
